import commitSelection from './commitSelection';
import { isMasterSelectionContext } from './selectionContext';
import applySelectionCommitToState, { buildSelectionFeedback } from './applySelectionCommitToState';
import { EMPTY_SELECTION } from './selectionState';

const isChannelSelectionActive = (selection) => (
  selection.keys.length > 0 && !isMasterSelectionContext(selection.context)
);

export default function applyTreeSelectionCommitToState(state, commitOptions) {
  if (isChannelSelectionActive(state.ui.selection)) {
    if (commitOptions.keepChannelSelection) {
      applySelectionCommitToState(state, commitOptions);
      return;
    }

    const previousSelection = state.ui.selection;
    const { selection, result } = commitSelection(EMPTY_SELECTION, commitOptions);

    if (!result.ok) {
      state.ui.selectionFeedback = buildSelectionFeedback(previousSelection, result);
      return;
    }

    state.ui.selection = selection;
    state.ui.selectionFeedback = null;
    return;
  }

  applySelectionCommitToState(state, commitOptions);
}
